export default __webpack_public_path__ + "static/media/Template - Business-Plan.fc84f641.docx";